import fieldType from '@/enums/fieldType'
import vuei18n from '@/plugins/vuei18n'
import store from '@/store/store'

class AclRouteBuilder{
  constructor(acl){
    this.acl = acl
    this.stack = []
  }

  can(permision){
    this.stack.push({ 'name' : permision })
    return this
  }

  and(permision){
    this.stack[this.stack.length - 1 ].operator = 'AND'
    this.can(permision)
    return this
  }

  or(permision){
    this.stack[this.stack.length - 1].operator = 'OR'
    this.can(permision)
    return this
  }

  build(){
    return  (to,from,next) => this.buildFunction(to,from,next, 0)
  }



  buildFunction(to,from,next, key){
    let permission = this.stack[key]
    if (this.acl.isAllowed(permission.name)) {

      if(key < (this.stack.length-1) && permission.operator == "AND"){
        return this.buildFunction(to,from,next, key + 1)
      }

      return next()

    }else{
      if(key < (this.stack.length-1) && permission.operator == "OR"){
        return this.buildFunction(to,from,next, key + 1)
      }

      store.commit("setSnack", {
        "message": vuei18n.t('base.permission_denied'),
        "color": "info"
      })
      return next({ name: 'login' })
    }
  }
}

export default class Acl {
  constructor () {
    this.initUser()
  }

  routeGuardBuilder(){
    return new AclRouteBuilder(this)
  }

  isAdmin(){
    if(this.user == undefined){
      return false
    }
    return this.user.role == 'admin'
  }

  isWorker(){
    if(this.user == undefined){
      return false
    }
    return this.user.role == 'worker'
  }

  isAllowed(permision){
    if(!this.userIsStored() && !this.initUser()){
      return false
    }

    return this.user.permissions.includes(permision)
  }

  hasRole(role){
    if(!this.userIsStored() && !this.initUser()){
      return false
    }

    return this.user.role == role
  }

  initUser(){
    let userEncoded = window.localStorage.getItem('user')
    if(userEncoded){
      this.user = JSON.parse(decodeURIComponent(escape(window.atob(userEncoded))))
      return true
    }
  }

  userIsStored(){
    if(this.user == undefined){
      return false
    }
    return true
  }

}
